import { pipe, filter, curry } from 'ramda'

const toString = (separator, array) =>
  pipe(
    filter(item => !!item || typeof item === 'number'),
    filteredArray => (filteredArray.length > 0 ? filteredArray.join(separator) : null)
  )(array)

export default curry(toString)
